const sendPennylaneUpdateClientDeliveryAddress = async (
  client_id,
  delivery_address,
  token,
  prefix
) => {
  const url = prefix + "pennylane/update-client-delivery-address";

  const body = {
    client_id,
    delivery_address,
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      console.error(`Failed to update delivery address: ${response.status}`);
      return { success: false };
    }

    return await response.json();
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    return { success: false };
  }
};

export default sendPennylaneUpdateClientDeliveryAddress;
